import { axiosClient } from '@/shared/apis/config';
import {
  DtoAspectRatio,
  DtoOutputLength,
  DtoProjectStatus,
  DtoProjectType,
  DtoResolution,
} from '@/shared/constants';
import { ApiResponse, CustomQueryOptions } from '@/shared/types';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

export const getProjectSimpleResponseSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: z.nativeEnum(DtoProjectType),
  outputLength: z.nativeEnum(DtoOutputLength),
  aspectRatio: z.nativeEnum(DtoAspectRatio),
  basePrompt: z.string(),
  resolution: z.nativeEnum(DtoResolution),
  status: z.nativeEnum(DtoProjectStatus),
  createdAt: z.string(),
  updatedAt: z.string(),
  creationStepCurrentIndex: z.number(),
  creationStepTotalCount: z.number(),
  isDeleted: z.boolean().optional(),
  creatorAccountId: z.number().nullable().optional(),
  creatorName: z.string().nullable().optional(),
  creatorEmail: z.string().nullable().optional(),
});
export type GetProjectSimpleResponseType = z.infer<
  typeof getProjectSimpleResponseSchema
>;

type ResponseType = ApiResponse<GetProjectSimpleResponseType>;
export const getProjectSimpleApi = async (projectId: number) => {
  try {
    const response = await axiosClient.get<ResponseType>(
      `/v1.0/project/${projectId}/simple`,
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const QueryKeyUseGetProjectSimpleApi = 'getProjectSimple' as const;
export const useGetProjectSimpleApi = (
  projectId: number,
  queryOptions?: CustomQueryOptions<ResponseType>,
) => {
  const { queryKey, ...rest } = queryOptions ?? {};

  return useQuery({
    queryKey: [QueryKeyUseGetProjectSimpleApi, projectId, ...(queryKey ?? [])],
    queryFn: () => getProjectSimpleApi(projectId),
    ...rest,
  });
};
